import { render, staticRenderFns } from "./ModalCombineFields.vue?vue&type=template&id=2c862ee1&scoped=true&"
import script from "./ModalCombineFields.vue?vue&type=script&lang=js&"
export * from "./ModalCombineFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c862ee1",
  null
  
)

export default component.exports